module.exports = __webpack_public_path__ + "static/media/pixels-and-print-1200x630.0744aec1.jpg";